//将字符串formatter函数用eval执行插件
export default {
  methods: {
    formaterStringToFuncPlugin(opt) {
      if (this.hasProperty(opt, "yAxis.axisLabel.formatterEv") && opt.yAxis.axisLabel.formatterEv === "custom") {
        let seriesLen = opt.series.length
        let maxL = 100
        if(opt.yAxis.dataValueLengthControl){
          maxL = parseInt(opt.yAxis.dataValueLength)
        }
        opt.yAxis.axisLabel.formatter = function (value, index) {
             // if(opt.yAxis.dataValueLengthControl){
             //   value = value.length > opt.yAxis.dataValueLength ? value.slice(0, opt.yAxis.dataValueLength) + "..." : value
             // }
          if(seriesLen ===1 ){
            if(opt.yAxis.dataValueLengthControl){
              value = value.length <= maxL ? value : value.slice(0, maxL) + "..."
            }
            return "{title|" + value + "} \n{rank" + index + "|" + (index + 1) + "}"
          }else{
            return "{title|" + value + "} \n\n\n"
          }
        }
      } else if (
        this.hasProperty(opt, "yAxis.axisLabel.formatterEv") &&
        opt.yAxis.axisLabel.formatterEv.indexOf("function") !== -1
      ) {
        const fn = new Function("opt", opt.yAxis.axisLabel.formatterEv)
        fn(opt)
      }
      // if (this.hasProperty(opt, "xAxis.axisLabel.formatterEv")) {
      //   eval(opt.xAxis.axisLabel.formatterEv)
      // }
    }
  }
}
